<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1250px'"
    :classDialog="'dialogTransferHandling'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">
          Chuyển xử lý văn bản đến
        </h2>
        &nbsp;&nbsp;
        <div class="title-content">
          <el-tag class="priority lv3">
            {{ quote }}
          </el-tag>
        </div>
      </div>
      <!-- body -->

      <el-tabs v-model="activeTabName">
        <el-tab-pane label="Chuyển Lãnh đạo duyệt" name="firstTab">
          <el-row class="dialog-body margin-0" :gutter="24">
            <el-col :span="12" class="list-collapse__transfer">
              <div class="flex-row flex__left margin-bottom-10">
                <el-input
                  prefix-icon="el-icon-search"
                  size="medium"
                  placeholder="Tìm kiếm theo tên/emai/đơn vị/chức vụ"
                  @input="searchTree"
                  v-model="query"
                ></el-input>
              </div>
              <hashtag-common
                :stepId="stepId"
                @selectTags="
                  event =>
                    selectTags(event, defaultProcessType || PROCESS_TYPE.NHANDEBIET)
                "
              />
              <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
                <el-tree
                  :data="roots1"
                  :filter-node-method="filterTree"
                  ref="departmentTree"
                  class="filter-tree"
                  default-expand-all
                >
                  <div
                    class="custom-tree-node flex-row flex__between width__100"
                    slot-scope="{ node, data }"
                  >
                    <div class="field-1">
                      <span>
                        <el-checkbox
                          v-model="data.checked"
                          @change="checkedChangeEvent(data)"
                        ></el-checkbox>
                        <span
                          v-if="
                            data.nodeType ===
                              DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                          "
                        >
                          <span class="font-weight__bold">
                            {{ data.userDeptRole.fullName }}
                          </span>

                          <span class="font-size__small font-italic">
                            ({{ data.userDeptRole.positionName }})
                          </span>
                           <span style="position: relative">
                               <el-tooltip
                                 v-if="data.userDeptRole.absentCount&&data.userDeptRole.absentCount!=0"
                                 :content="tooltipContent(data.userDeptRole)"
                                 placement="right"
                                 effect="dark">
                               <absent-notify></absent-notify>
                             </el-tooltip>
                          </span>
                        </span>
                        <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
                      </span>
                    </div>
                  </div>
                </el-tree>
              </VuePerfectScrollbar>
            </el-col>
            <el-col :span="12" class="display-list__selected">
              <!-- chuyen xu ly -->
              <div
                :class="['list-selected', isLanhDao ? 'withAutoAssignTask' : '']"
              >
                <!-- title -->
                <div class="header">
                  <div class="flex-row flex__between">
                    <h5 class="title margin-0">Danh sách chuyển xử lý</h5>
                    <div class="list-checkbox flex-row flex__right margin-right-10">
                      <h5
                        class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                      >
                        <span class="margin-bottom-5">Chủ trì</span>
                        <span>
                          <el-radio
                            v-model="processType"
                            :label="PROCESS_TYPE.CHUTRI"
                            @change="checkAllProcessType"
                            class="radio_chuyenXuLy"
                          ></el-radio>
                        </span>
                      </h5>
                      <h5
                        class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                      >
                        <span class="margin-bottom-5">Phối hợp</span>
                        <span>
                          <el-radio
                            v-model="processType"
                            :label="PROCESS_TYPE.PHOIHOP"
                            @change="checkAllProcessType"
                            class="radio_chuyenXuLy"
                          >
                          </el-radio>
                        </span>
                      </h5>
                      <h5
                        class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                      >
                        <span class="margin-bottom-5">Nhận để biết</span>
                        <span>
                          <el-radio
                            v-model="processType"
                            :label="PROCESS_TYPE.NHANDEBIET"
                            @change="checkAllProcessType"
                            class="radio_chuyenXuLy"
                          >
                          </el-radio>
                        </span>
                      </h5>
                    </div>
                  </div>
                </div>
                <!-- end_title -->
                <div class="body">
                  <div class="list-filter">
                    <VuePerfectScrollbar
                      class="scroll-list-user"
                      :settings="perfectScrollbarSetting"
                    >
                      <div
                        v-for="(item, index) in selectedHandlersData"
                        :key="index"
                        class="selected-user flex-row flex__between"
                      >
                        <div class="title flex-row flex__left">
                          <div class="clickable margin-right-10">
                            {{ index + 1 }}.
                          </div>
                          <div
                            class="flex-row flex__left"
                            v-if="
                              item.data.nodeType ===
                                DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                            "
                          >
                            <div class="avt">
                              <div
                                class="avatar-fake font-size__small margin-right-10 flex-row flex__center"
                              >
                                <span>{{
                                    item.data.userDeptRole.fullName
                                      | buildShortNameFilter
                                  }}</span>
                              </div>
                            </div>
                            <div class="info">
                              <p class="people__name">
                                {{ item.data.userDeptRole.fullName }}
                              </p>

                              <p class="people__position margin-0">
                                {{ item.data.userDeptRole.positionName }} -
                                {{ item.data.userDeptRole.deptName }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="flex-row flex__left"
                            v-else-if="
                              item.data.nodeType === DEPARTMENT_TREE.NODE_TYPE.DEPT
                            "
                          >
                            <div class="avt"></div>
                            <div class="info">
                              <p class="people__name">
                                {{ item.data.department.deptName }}
                              </p>
                              <p class="people__position margin-0">
                                ({{ item.data.department.identityCode }})
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          class="list-checkbox flex-row flex__right margin-right-10"
                        >
                          <template>
                            <el-radio
                              class="item txt-center"
                              v-model="item.processType"
                              :label="PROCESS_TYPE.CHUTRI"
                              @change="refreshProcessType()"
                            >&nbsp;
                            </el-radio>
                            <el-radio
                              class="item txt-center"
                              v-model="item.processType"
                              :label="PROCESS_TYPE.PHOIHOP"
                              @change="refreshProcessType()"
                            >
                              &nbsp;
                            </el-radio>
                            <el-radio
                              class="item txt-center"
                              v-model="item.processType"
                              :label="PROCESS_TYPE.NHANDEBIET"
                              @change="refreshProcessType()"
                            >
                              &nbsp;
                            </el-radio>
                          </template>

                          <i
                            class="icon-close color__red clickable font-size__medium el-icon-circle-close"
                            @click="removeFromSelectedHandlersData(item)"
                          ></i>
                        </div>
                      </div>
                    </VuePerfectScrollbar>
                  </div>
                </div>
              </div>
              <el-form label-position="top">
                <el-form-item label="Ý kiến/đề xuất">
                  <el-input
                    type="textarea"
                    resize="none"
                    :autosize="{ minRows: 2, maxRows: 2 }"
                    placeholder="_"
                    v-model="form.note"
                  />
                </el-form-item>
<!--                <el-tooltip-->
<!--                  v-if="isLanhDao"-->
<!--                  content="Khi chuyển văn bản, công việc sẽ được tạo tự động cho đơn vị/cá nhân chủ trì"-->
<!--                  placement="top"-->
<!--                >-->
<!--                  <el-checkbox class="margin-top-5" v-model="form.isAutoAssignTask"-->
<!--                  >Tự động giao việc-->
<!--                  </el-checkbox>-->
<!--                </el-tooltip>-->
              </el-form>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="submit"
          :disabled="isProcessing"
        >
          <i
            :class="[
              !isProcessing
                ? 'fas fa-check-circle font-size__small'
                : 'el-icon-loading'
            ]"
          ></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
import constants from "../../../constants";
import nextStepInfoViewService from "../../../services/nextStepInfoViewService";
import h from "../../../services/h";
import HashtagCommon from "./chuyenXuLy-hashtag";
import cxlVbdenCommonMixin from "../../../mixins/cxlVbdenCommonMixin";
import AbsentNotify from "../../common/absents/absent-notify";
import dateFormatter from "../../../filters/dateFormatter";
import departmentService from "../../../services/departmentService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import vbIncomingChoCxlProcessService from "../../../services/vbIncomingChoCxlProcessService";

export default {
  name: "cxl-vbden-common",
  mixins: [cxlVbdenCommonMixin],
  filters: {buildShortNameFilter},
  props: [
    "flowId",
    "stepId",
    "flag",
    "docId",
    "isOpen",
    "quote",
    "incomingProcessId",
    "nextVbIncomingProcess",
    "note",
    "isProcessing",
    "defaultProcessType"
  ],
  components: {
    AbsentNotify,
    HashtagCommon,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
    VuePerfectScrollbar
  },

  data() {
    return {
      activeTabName: 'firstTab',
      roots1: [],
      selectedHandlers: []
    }
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    isLanhDao() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
      );
    },
    isNhanhDang() {
      return (
        this.userDeptRole &&
        this.userDeptRole.deptPath.includes('/TCT/DU', 0)
      );
    },
    isChoDuyetCxl() {
      return this.flag === constants.STEP.FLAG_CHO_DUYET_CXL;
    },
    isDuyetCxl() {
      return this.flag === constants.STEP.FLAG_DUYET_CXL;
    }
  },

  watch: {},

  created() {
    this.initForm();
  },

  methods: {
    // Neu la user co role lanh dao cua Vien kiem sat tinh QN (role lanh dao cao nhat - tuong duong lanh dao TCT)
    isLDVienKiemSatQN() {
      return this.userDeptRole.tenantCode === constants.TENANT_CODE.VIENKIEMSATQN
        && this.userDeptRole.deptPath === '/TCT'
        && this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO;
    },

    tooltipContent(item){
      return `Vắng mặt từ `+dateFormatter(item.absentStartTime)+` đến `+dateFormatter(item.absentDeadlineTime);
    },

    checkedChangeEvent(data, ) {
      let isCheckStrictly = false;

      // Neu la user co role lanh dao cua Vien kiem sat tinh QN
      if (this.isLDVienKiemSatQN()) {
        isCheckStrictly = true;
      }

      this.checkedChange(
        data,
        data.isHandlerNode
          ? constants.PROCESS_TYPE.CHUTRI
          : this.defaultProcessType || constants.PROCESS_TYPE.NHANDEBIET,
        isCheckStrictly
      );
    },

    async initForm() {
      this.form.note = this.note;
      // await this.initSelectedHandlers();

      // Neu la user co role lanh dao cua Vien kiem sat tinh QN
      if (this.isLDVienKiemSatQN()) {
        await this.buidNodesCXLListV2();
      } else {
        await this.buidNodesCXLList();
      }

    },

    /**
     * Ham lay user, department trong cac next step roi build thanh tree
     * Voi cac department trong next step la don vi thi se lay cac user co role lanh dao, chuyen vien trong department do
     * Ham nay hien tai dang dung cho tenant vienkiemsatqn
     * @returns {Promise<*>}
     */
    buidNodesCXLListV2() {
      if(this.roots1.length !== 0) return;
      return this.getDepartmentsAndUsersInNextStep(this.flowId, this.stepId)
        .then(res => {
          if (!res.udrs || !res.depts || res.udrs.length < 1 | res.depts.length < 1) return;

          this.userDeptRoleHandlers = res.udrs;
          this.departmentHandlers = res.depts;
          this.filterAllAlreadyForwardedHandlers();
          this.buildNodes().then(() => {
            this.roots1 = [...this.roots];
            h.each(this.roots1, root =>
              this.markCheckedForSelectedHandlers(root)
            );
            this.refreshProcessType();
          });
        });
    },

    // Load va build node danh sach chuyen xu ly
    buidNodesCXLList() {
      if(this.roots1.length !== 0) return;
      return this.loadNextStepsInfo(this.flowId, this.stepId)
        .then(nextSteps => {
          this.nextSteps = nextSteps;
          return this.loadHandlers(this.stepId, nextSteps);
        })
        .then(results => {
          let userDeptRolesSet = results[0];
          let departments = results[1];
          this.userDeptRoleHandlers = userDeptRolesSet;
          this.departmentHandlers = departments;
          this.filterAllAlreadyForwardedHandlers();
          this.buildNodes().then(() => {
            this.roots1 = [...this.roots];
            h.each(this.roots1, root =>
              this.markCheckedForSelectedHandlers(root)
            );
            this.refreshProcessType();
          });
        });
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    loadDepartmentHandlers(deptCode) {
      return departmentService.findAllByDeptCodeAndIncludeSubDepts(deptCode)
        .then(response => (this.departmentHandlers = response.data));
    },

    async loadHandlers_() {
      let userDeptRoleHandlers = [];
      await userDeptRoleViewService.findAllLanhDaoByDeptCode(this.$store.getters.globalRoles)
        .then(response => (userDeptRoleHandlers.push(...response.data)));
      await userDeptRoleViewService.findAllByDeptCode(constants.HDTV_DEPT_CODE)
        .then(response => (userDeptRoleHandlers.push(...response.data)));
      this.userDeptRoleHandlers = userDeptRoleHandlers;
    },

    loadNextStepsInfo(flowId, stepId) {
      return nextStepInfoViewService
        .nextSteps(flowId, stepId)
        .then(response => response.data);
    },

    markCheckedForSelectedHandlers(data) {
      h.each(data.children, child =>
        this.markCheckedForSelectedHandlers(child)
      );

      let selectedHandler;
      let nodeType = data.nodeType;
      switch (nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          let department = data.department;
          selectedHandler = h.find(
            this.selectedHandlers,
            item =>
              item.stepType === constants.STEP.STEP_TYPE.DONVI &&
              department.id === item.department.id
          );
          break;
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          let userDeptRole = data.userDeptRole;
          selectedHandler = h.find(
            this.selectedHandlers,
            item =>
              item.stepType === constants.STEP.STEP_TYPE.CANHAN &&
              userDeptRole.id === item.userDeptRole.id
          );
          break;
        default:
          break;
      }

      if (selectedHandler) {
        if (data.isHandlerNode) {
          this.$set(data, "checked", true);
          this.addOrRemoveToSelectedHandlers(data, selectedHandler.processType);
        } else {
          if (!data.checked) {
            this.$set(data, "checked", true);
            h.each(data.children, child => {
              this.$set(child, "checked", true);
              this.addOrRemoveToSelectedHandlers(child, selectedHandler.processType);
            });
          }
        }
      } else if(!data.isHandlerNode) {
        let isAllChildNodesChecked = !h.exists(
          data.children,
          child => !child.checked
        );
        this.$set(data, "checked", isAllChildNodesChecked);
      }
    },

    filterAllAlreadyForwardedHandlers() {
      this.userDeptRoleHandlers = h.findAll(
        this.userDeptRoleHandlers,
        userDeptRole =>
          h.indexOf(
            this.nextVbIncomingProcess,
            process =>
              process.stepType === constants.STEP.STEP_TYPE.CANHAN &&
              (process.receiverUserDeptRoleId === userDeptRole.id ||
                (process.receiverId === userDeptRole.userId &&
                  process.deptReceiverId === userDeptRole.deptId &&
                  process.roleReceiverId === userDeptRole.roleId))
          ) === -1
      );

      this.departmentHandlers = h.findAll(
        this.departmentHandlers,
        department =>
          h.indexOf(
            this.nextVbIncomingProcess,
            process =>
              process.stepType === constants.STEP.STEP_TYPE.DONVI &&
              process.deptReceiverId === department.id
          ) === -1
      );
    },

    submit() {
      if (!this.validate()) return;
      const handlersData = this.processSelectedHandlerData(this.selectedHandlersData);
      this.$emit("submit",
        {
          handlersData: handlersData,
          note: this.form.note,
          isAutoAssignTask: this.form.isAutoAssignTask
        }
      );
    },

    processSelectedHandlerData(selectedHandlersData) {
      let handlersData = [];
      selectedHandlersData
        .filter(
          item =>
            item.data.nodeType ===
            constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
        )
        .forEach(item => {
          handlersData.push({
            userDeptRole: item.data.userDeptRole,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.CANHAN
          });
        });

      selectedHandlersData
        .filter(
          item =>
            item.data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
        )
        .map(item => {
          handlersData.push({
            department: item.data.department,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.DONVI
          });
        });
      return handlersData;
    },

    initSelectedHandlers() {
      /*
      * Chỉ load checkedHandler khi flag là: DUYET_CXL
      * */
      if(this.flag !== constants.STEP.FLAG_DUYET_CXL) return;

      return vbIncomingChoCxlProcessService.findAllByDocId(this.docId)
        .then(response => {
          const handlers = response.data;
          const deptHandlers = h.findAll(handlers, item => item.stepType === constants.STEP.STEP_TYPE.DONVI);
          const userDeptRoleHandlers = h.findAll(handlers, item => item.stepType === constants.STEP.STEP_TYPE.CANHAN);

          h.each(deptHandlers, item => this.selectedHandlers.push({
            stepType: constants.STEP.STEP_TYPE.DONVI,
            department: {
              id: item.deptReceiverId
            },
            processType: item.processType
          }));

          h.each(userDeptRoleHandlers, item => this.selectedHandlers.push({
            stepType: constants.STEP.STEP_TYPE.CANHAN,
            userDeptRole: {
              id: item.receiverUserDeptRoleId
            },
            processType: item.processType
          }));
        })
    }
  }
};
</script>
<style scoped>
.title {
  width: 100%;
}

.list-checkbox {
  position: relative;
  margin-right: 10px;
}

.scroll-list-user {
  height: auto;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.list-checkbox .item {
  width: 90px;
  text-align: center;
  margin: 0;
}

.icon-close {
  position: absolute;
  right: -5px;
  font-size: 18px;
}

.dialog-body .display-list__selected .list-selected .header > div {
  width: 100%;
}

.dialog-body .display-list__selected .list-selected .body {
  padding: 0;
}

.dialogTransferHandling .dialog-body .list-collapse__transfer {
  display: flex;
  flex-direction: column;
}

.dialogTransferHandling .dialog-body .scroll-area-height_90 {
  height: 100%;
  margin-bottom: 0;
  margin-right: -13px;
}

.dialog-body .display-list__selected {
  height: 400px;
}

.dialogTransferHandling .dialog-body .display-list__selected .list-selected {
  height: calc(100% - 121px);
}

.dialogTransferHandling
.dialog-body
.display-list__selected
.list-selected.withAutoAssignTask {
  height: calc(100% - 145px) !important;
}

.dialog-body .display-list__selected .list-selected .header {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-body .display-list__selected .list-selected .body .list-filter {
  height: 100%;
}

/*.dialogTransferHandling .dialog-body .list-collapse__transfer {*/
/*  height: 405px;*/
/*}*/

/*.pScrollDialog {*/
/*  height: 405px!important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-cho-cxl-ld.vue